import { UrbanFeaturePage } from "@/pages/urban-feature";
import { CitiesPage } from "pages/cities";
import { ClientDetailPage } from "pages/client-detail";
import { CurbZonePage } from "pages/curb-zone-page";
import { RestrictionPage } from "@/pages/restriction-page";
import ErrorPage from "pages/error-page";
import MiddleWare from "./middleware";
import { NotFoundPage } from "pages/404";
import { OffstreetParkingPage } from "pages/offstreet-parking";
import { ParkingPaymentPage } from "pages/parking-payment";
import { PoliciesPage } from "pages/policies-page";
import { UsersPage } from "pages/users";
import { createBrowserRouter } from "react-router-dom";
import { routes } from "./constants";
import { StreetStatisticsPage } from "pages/street-statistics-page";
import { FinancePage } from "pages/finance-page";

export const router = createBrowserRouter([
  {
    element: <MiddleWare />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: routes.root.path,
        element: <CurbZonePage />,
      },
      {
        path: routes.offstreetParking.path,
        element: <OffstreetParkingPage />,
      },
      {
        path: routes.restriction.path,
        element: <RestrictionPage />,
      },
      {
        path: routes.cities.path,
        element: <CitiesPage />,
      },
      {
        path: routes.users.path,
        element: <UsersPage />,
      },
      {
        path: routes.clientDetail.path,
        element: <ClientDetailPage />,
      },
      {
        path: routes.policies.path,
        element: <PoliciesPage />,
      },
      {
        path: routes.parkingPayment.path,
        element: <ParkingPaymentPage />,
      },
      {
        path: routes.streetStatistics.path,
        element: <StreetStatisticsPage />,
      },
      {
        path: routes.urbanFeature.path,
        element: <UrbanFeaturePage />,
      },
      {
        path: routes.finance.path,
        element: <FinancePage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
  { path: routes.notfound.path, element: <NotFoundPage /> },
  { path: routes.error.path, element: <ErrorPage /> },
]);
